import Vue from 'vue/dist/vue.common';
import $ from 'jquery';
import Component from '../../js/lib/component';
import ProductItem from '../product-item/product-item.vue';
import store, { eventBus } from '../../js/Store';

const classList = {
  root: '.js-cart-list'
};

export default class CartList extends Component {
  init() {
    const scope = this;

    new Vue({
      name: 'CartList',
      data: {
        inited: false
      },
      el: this.$.root.get(0),
      computed: {
        products() {
          return store.getters.products;
        }
      },
      store,
      components: {
        'product-item': ProductItem
      },
      mounted() {
        scope.$.root = $(this.$el);
        scope.elements();

        eventBus.$on('product.remove', () => {
          if (!store.getters.products.length) {
            window.location.reload();
          }
        });

        this.inited = true;
      }
    });
  }
}

Component.mount(CartList, {
  name: 'CartList',
  classList,
  state: {}
});
